module.exports = __webpack_public_path__ + "img/avatar-placeholder.67742697.svg";